module.exports = __webpack_public_path__ + "static/media/progPhotoPlaceholder.7138bed2.png";